import * as React from 'react';
import type { Location, Territory } from '@hetivo/hetivo-lib-types';
import { useTranslation } from 'react-i18next';
import { LocationResult } from './location-result';
import { TerritoryResult } from './territory-result';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface ResultsListProps {
  locations: Location[];
  onClose: () => void;
  territories: Territory[];
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ResultsList({ locations, onClose, territories }: ResultsListProps): React.JSX.Element {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col pb-2">
      {territories.length > 0 && (
        <div>
          <div className="px-3 py-1.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
              {t('mainSelector.territories')}
            </span>
          </div>
          {territories.map((territory) => (
            <TerritoryResult key={territory.id} onClose={onClose} territory={territory} />
          ))}
        </div>
      )}
      {locations.length > 0 && (
        <div>
          <div className="px-3 py-1.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
              {t('mainSelector.locations')}
            </span>
          </div>
          {locations.map((location) => (
            <LocationResult key={location.id} location={location} onClose={onClose} />
          ))}
        </div>
      )}
    </div>
  );
}
